import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { Children, useMemo } from 'react';
export default function useSlots(component, children) {
  return useMemo(function () {
    return Children.toArray(children).reduce(function (res, el) {
      var _a, _b;
      var _ref = ((_b = (_a = el === null || el === void 0 ? void 0 : el.type) === null || _a === void 0 ? void 0 : _a.slot) === null || _b === void 0 ? void 0 : _b.split(':')) || [],
        _ref2 = _slicedToArray(_ref, 2),
        target = _ref2[0],
        slot = _ref2[1];
      if (!target || target !== component) {
        res['children'] = [].concat(_toConsumableArray(res['children'] || []), [el]);
      }
      if (target === component && slot) {
        res[slot] = [].concat(_toConsumableArray(res[slot] || []), [el]);
      }
      return res;
    }, {});
  }, [children, component]);
}